import { color, font } from "theme/aiInventory";

export type EmptyStateProps = {
  title: string;
  hint?: string;
};

/**
 * A minimal, theme-matching empty state. Two hairline rules + a
 * 45° slash stand in for antd's default "no data" illustration,
 * which feels out of place in this inventory surface.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ title, hint }) => (
  <div
    role="status"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      padding: "36px 20px",
      color: color.inkMute,
      fontFamily: font.sans,
    }}
  >
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      aria-hidden
      style={{ opacity: 0.7 }}
    >
      <line
        x1="8"
        y1="28"
        x2="22"
        y2="28"
        stroke={color.ruleStrong}
        strokeWidth="1"
        strokeDasharray="3 3"
      />
      <line
        x1="34"
        y1="28"
        x2="48"
        y2="28"
        stroke={color.ruleStrong}
        strokeWidth="1"
        strokeDasharray="3 3"
      />
      <line
        x1="24"
        y1="40"
        x2="32"
        y2="16"
        stroke={color.ink}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
    <div
      style={{
        fontSize: 13,
        fontWeight: 500,
        color: color.ink,
        letterSpacing: "-0.005em",
      }}
    >
      {title}
    </div>
    {hint && (
      <div
        style={{
          fontSize: 11,
          fontFamily: font.mono,
          color: color.inkMute,
          textAlign: "center",
          maxWidth: 320,
        }}
      >
        {hint}
      </div>
    )}
  </div>
);
